// types.ts

import { Control } from "react-hook-form";
import { Theme, SxProps } from "@mui/material";
import { Order } from "../../../orders/utils/types";

/* =======================================================
   VARIANT
======================================================= */

export const PROFIT_MODE = {
  ACTUAL: "actual",
  ESTIMATED: "estimated",
  OVERRIDDEN: "overridden",
} as const;

export type ProfitMode = (typeof PROFIT_MODE)[keyof typeof PROFIT_MODE];

export type Variant = "positive" | "negative" | "neutral";
export type FinancialFieldKey =
  | "salesPrice"
  | "productCost"
  | "shippingCost"
  | "warehouseCost"
  | "commission"
  | "totalPromotionDiscount"
  | "sellerRefund"
  | "buyerRefund"
  | "totalTax"
  | "profit";

export type FinancialRowConfig = {
  key: FinancialFieldKey;
  label: string;
  estimated?: boolean;
  editable?: boolean;
  variant?: Variant;
  hideIfZero?: boolean;
};

export const FINANCIAL_ROWS: FinancialRowConfig[] = [
  { key: "salesPrice", label: "price", variant: "positive" },
  { key: "productCost", label: "productCost", variant: "negative" },
  {
    key: "shippingCost",
    label: "shippingCost",
    variant: "negative",
    hideIfZero: true,
  },
  { key: "warehouseCost", label: "warehouseCost", variant: "negative" },
  { key: "commission", label: "commission", variant: "negative" },
  {
    key: "totalPromotionDiscount",
    label: "promotionDiscount",
    variant: "neutral",
  },
  { key: "totalTax", label: "tax", variant: "negative", hideIfZero: true },
  { key: "buyerRefund", label: "buyerRefund", variant: "negative" },
  { key: "sellerRefund", label: "sellerRefund", variant: "positive" },
  { key: "profit", label: "profit", variant: "positive" },
];
/* =======================================================
   REPORT VIEW
======================================================= */

export type FinancialReportView = Partial<Record<FinancialFieldKey, number>>;

/* =======================================================
   FORM MODEL
======================================================= */

export type ProfitFormValues = Partial<Record<FinancialFieldKey, number>>;
/* =======================================================
   RENDER PARAMS
======================================================= */

export type PriceRowRenderParams = {
  control: Control<ProfitFormValues>;
  inputSx?: SxProps<Theme>;
  currency?: string;
  usdValue: string;
};

/* =======================================================
   SAVE REGISTER CONTRACT
======================================================= */

export type RegisterSaveResult = {
  isDirty: boolean;
  reset: () => void;
};

export type RegisterSaveFn = (
  _cb: (_payload: ProfitFormValues) => void,
) => RegisterSaveResult;

/* =======================================================
   CONTAINER PROPS
======================================================= */

export type OrderProfitProps = {
  Order: Order;
};
